<h4 mat-dialog-title>
    {{'risks.report_title' | translate}}
</h4>

<mat-dialog-content class="content">
    <mat-form-field appearance="outline" class="input-full-width">
        <mat-label>
            {{ "risks.report_type" | translate }}
        </mat-label>

        <mat-select name="model" [(ngModel)]="reportType">
            <mat-option *ngFor="let entry of reportTypeLabels | keyvalue" [value]="entry.key">{{ entry.value }}</mat-option>
        </mat-select>
    </mat-form-field>

    <mat-form-field *ngIf="reportType=='other'" class="input-full-width" appearance="outline">
        <mat-label>
            {{ "risks.comment" | translate }}
        </mat-label>

        <textarea matInput [(ngModel)]="comment" rows="4"></textarea>
      </mat-form-field>
</mat-dialog-content>

<mat-dialog-actions class="actions">
    <lib-button [icon]="'close'" [text]="'form.cancel' | translate" [color]="'warning'" (click)="dismiss()">
    </lib-button>
    <lib-button [icon]="'done'" [color]="'primary'" [text]="'form.submit' | translate" (click)="ok()" [disabled]="!reportType || (reportType == 'other' && !comment)">
    </lib-button>
</mat-dialog-actions>
